module.exports = __webpack_public_path__ + "static/img/4areaB_6.78cc78c.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/character2/4areaB_6.png
// module id = 1186
// module chunks = 1